import { createTheme } from '@mui/material'

export const defaultLandingTheme = createTheme({
    palette: {
        primary: {    
            main: '#3273de'//'#214c45', can't use dark teal because is indistingishable from black AZ-30
        }
    },
})

export const defaultLandingModulesTheme = createTheme({
    palette: {
        primary: {    
            main: '#3273de'//'#214c45', can't use dark teal because is indistingishable from black AZ-30
        }
    },
})

export const defaultGridButtonsTheme = createTheme({
    palette: {
        primary: {
            main: '#3273de'//'#214c45', can't use dark teal because is indistingishable from black 
        }
    },
})

export const defaultNavBarTheme = createTheme({
    palette: {
        primary: {    
            main: '#3273de'//'#214c45', can't use dark teal because is indistingishable from black 
        }
    },
})
